import { render, staticRenderFns } from "./LgFinderPageUnidadeFederativa.vue?vue&type=template&id=0febb85f"
import script from "./LgFinderPageUnidadeFederativa.vue?vue&type=script&lang=js"
export * from "./LgFinderPageUnidadeFederativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports